import { IEvent } from '@adage/ace-calendar';
import * as moment from 'moment';

export interface IDay {
    date: string;
    events: Array<IMainstreetEvent>;
}

export interface MultiLocation {
    format: string;
    location: string;
}
export interface IMainstreetEvent extends IEvent {
    buyTicketsLink: string;
    buyTicketsText: string;
    category: string;
    eventDate: Date;
    id: number;
    name: string;
    courseType: string;
    location: string;
    detailPageLink: string;
    eventTimeString: string;
    eventDateString: string;
    isAvailable: boolean;
    availablityErrorMessage: string;
    eventType: string;
    format: string;
    instructor: string;
    isFree: boolean;
    isMemberOnly: boolean;
    memberPrice: string;
    showMemberPrice: boolean;
    nonMemberPrice: string;
    thumbnailUrl: string;
    disableRegister: boolean;
}

export interface IEventMonth<T extends IEvent> {
    monthMoment: moment.Moment;
    events: Array<T>;
}

export interface ICalendarState<T extends IEvent> {
    updating: boolean;
    specificDates: boolean;
    extendEvents: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    currentDate: moment.Moment;
    eventFilter: IEventFilter[];
    filterFunction: any;
    events: Array<T>;
    courseTypeFilter: Array<string>;
    eventTypeFilter: Array<string>;
    formatFilter: Array<string>;
    instructorFilter: string;
    locationFilter: string;
    showOnlyFreeEvent: boolean;
    dispatch: any;
    offset: number;
    pageSize: number;
    hasMoreEvents: boolean;
    showAllMonths: boolean;
}

export const defaultCalendarModel: ICalendarState<IMainstreetEvent> = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment(moment().startOf('month')),
    endDate: moment(moment().startOf('month')).add(11, 'month').endOf('month'),
    currentDate: moment(moment()),
    eventFilter: [],
    filterFunction: () => { return true; },
    events: [],
    courseTypeFilter: [],
    eventTypeFilter: [],
    formatFilter: [],
    instructorFilter: '',
    locationFilter: '',
    showOnlyFreeEvent: false,
    dispatch: null,
    offset: 0,
    pageSize: 20,
    hasMoreEvents: false,
    showAllMonths: true
};

export interface ICalendarSettings {
    loadWrappingMonthDates: boolean;
    saveHistory: boolean;
}

export const calendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: true
}

export const mockCalendarModel: ICalendarState<IEvent> = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment('2015-05-01').startOf('month'),
    endDate: moment('2015-05-02').endOf('month'),
    currentDate: moment('2015-05-01'),
    eventFilter: [],
    filterFunction: () => { return true; },
    events: [],
    courseTypeFilter: [],
    eventTypeFilter: [],
    formatFilter: [],
    instructorFilter: '',
    locationFilter: '',
    showOnlyFreeEvent: false,
    dispatch: null,
    offset: 0,
    pageSize: 20,
    hasMoreEvents: false,
    showAllMonths: true
};

//export interface IProductionSeasonFilter {
//    productionSeasonId: number;
//    productionName: string;
//}

export interface IEventFilter {
    key: string;
    filter: Function;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/classes.ts